import React from "react";
import { useSnackBar } from "../../contexts";
import SnackBar from "./snackBar";

const SnackContainer = () => {
    const { snack } = useSnackBar();

    return (
        <div className="snackbar-container">
            <SnackBar
                message={snack?.message}
                className={snack?.className}
                isVisible={snack?.isVisible}
            />
        </div>
    );
};

export default SnackContainer;
